
import baseSpotRecordDetails from './baseSpotRecordDetails';
import baseAllowedStationCapabilities from './baseAllowedStationCapabilities'

export default (urlParameters) => {
  const { id, lat, lon, isSpot, isFavoriteSpot, isArbitrarySpot } = urlParameters;
  
  return {
    id,
    lat,
    lon,
    is_spot: isSpot,
    is_favorite_spot: isFavoriteSpot,
    is_arbitrary_spot: isArbitrarySpot,
    spotRecordDetail: baseSpotRecordDetails,
    allowed_station_capabilities: baseAllowedStationCapabilities,
    advisoryId: null,
    fx_model_id: null,
    nc_wind_data_enabled: null
  }
}